import { render, staticRenderFns } from "./edit-employee-group-header.vue?vue&type=template&id=67f6e638&scoped=true"
import script from "./edit-employee-group-header.vue?vue&type=script&lang=js"
export * from "./edit-employee-group-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f6e638",
  null
  
)

export default component.exports